module.exports = __webpack_public_path__ + "assets/img/logo20.f3401305.png";